module.exports = __webpack_public_path__ + "img/facebook.c03c84c.svg";